import * as React from 'react';
import { useCallback } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useEffect } from 'react';
import { getSlowQueryData } from '../../services/integrationService';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';



const headers: string[] = ['QUERY', 'AVG LATENCY', 'AVG ROWS SENT', 'AVG ROWS EXAMINED','AVG ROWS AFFECTED','FULL SCAN','EXEC COUNT','ERR COUNT','WARN COUNT','TOTAL LATENCY','MAX LATENCY','LOCK LATENCY','TMP TABLES','TMP DISK TABLES','ROWS SORTED','SORT MERGE PASSES','FIRST SEEN','LAST SEEN','DIGEST']; 




const SlowQueries: React.FC = () => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT = "Slow Queries"
    const [slowQueries, setSlowQueries] = React.useState<any[]>([]);
    const lob = localStorage.getItem('lob');
    const env = localStorage.getItem('env');



    const slowQueriesData = useCallback(async () => {
        if(lob && env){
       const data = await getSlowQueryData(lob,env);
       setSlowQueries(data.data);
        }
        
       
        
       
    }, []);
    useEffect(()=>{
        slowQueriesData()
        
      },[slowQueriesData]);

  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <TableCell sx={{ width:header === 'QUERY' || header === 'FIRST SEEN' || header === 'LAST SEEN' || header === 'DIGEST'
              ? '20%'
              : undefined,
               whiteSpace: 'nowrap', color: '#67748e',fontWeight:"bold"}}
              key={header} align="center">
                  {translate(TranslationEnum.slow_queries,header)}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
       
       <TableBody>
        {slowQueries.length===0 ? (
           <div
           style={{
             position: 'absolute',
             top: '50%',
             left: '50%',
             transform: 'translate(-50%, -50%)',
           }}
         >
           <div style={{ textAlign: 'center' }}>
             No data to show.
           </div>
         </div>
        ):(
           slowQueries.map((slowQuery) => (
            <TableRow  key={slowQuery.query}>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.query}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.avg_latency}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.rows_sent_avg}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.rows_examined_avg}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.rows_affected_avg}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.full_scan}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.exec_count}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.err_count}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.warn_count}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.total_latency}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.max_latency}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.lock_latency}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.tmp_tables}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.tmp_disk_tables}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.rows_sorted}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.sort_merge_passes}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.first_seen}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.last_seen}</TableCell>
              <TableCell align="center" sx={{ color: '#67748e' }}>{slowQuery.digest}</TableCell>
            </TableRow> 
           ))
           )} 
        </TableBody> 
      </Table>
    </TableContainer>
  );
};

export default SlowQueries;
